import { useEffect, useState } from 'react';

import { BalanceType, ContractBalanceOf } from '@/types';
import { useWeb3 } from '@/hooks/use-web3';
import { fiexdDecimal, NumWithComma } from '@/lib/BigNumbers';
import { METHODS_BALANCE_OF } from '@/lib/common/name-space';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function Balance(payload: BalanceType) {
  const { chainId, symbol, token } = payload;
  const { web3authCall, address } = useWeb3();
  const { isConnected } = useWeb3AuthConnect();
  const [amount, setAmount] = useState('0');
  useEffect(() => {
    (async () => {
      if (isConnected && address && web3authCall) {
        console.log(symbol);
        let res = null;
        if (token) {
          // erc20
          const payload: ContractBalanceOf = {
            method: METHODS_BALANCE_OF,
            symbol,
            address,
          };
          res = await web3authCall.getRpc().getTokenBalance(payload);
        } else {
          // 기반 코인
          res = NumWithComma(fiexdDecimal(await web3authCall.getRpc().getBalance(address)));
        }
        setAmount(res ? res : '0');
        // const re = await web3authCall.getRpc().getBalance(token, symbol, address);
        // console.log(`balance`);
        // console.log(re);
      }
    })();
    return () => {};
  }, [symbol, chainId, token, web3authCall]);

  return (
    <>
      {symbol} {amount}
    </>
  );
}
